import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/ContactForm/ContactForm.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/ContactForm/ContactForm.ts';

export const prototypeName = 'LNJVp8v364C0lNjJaKpdCNR114JD0zf2V3z32OP3s4AP5z049XiVD1zJqRzohw63d621ba';
export {styles};
export {script};